
import Vue from "vue";
import AppSidebarKeyValueList, { ISidebarKeyValueRow } from "./SidebarKeyValueList.vue";
import { printHumanFloat } from "@/utils/pretty-print";
import { BrowseStateBase } from "@/utils/browse/browse-state-base";

export default Vue.extend({
	props: {
		item: {
			type: Object as () => any,
			required: true
		},
		state: {
			type: Object as () => BrowseStateBase,
			required: true
		}
	},
	computed: {
		stats():any {
			let stats = this.item.Stats;
			if (!stats || !stats.ContactID) return null;
			return stats;
		},
		loading():boolean {
			return !this.stats && !this.state.sidebarItemLoaded;
		},
		totalRevenue():number {
			return this.stats ? (this.stats.TotalRevenue || 0) : 0;
		},
		totalOpen():number {
			return this.stats ? (this.stats.TotalOpen || 0) : 0;
		},
		rows():ISidebarKeyValueRow[] {
			return [
				{label: this.$ct("sidebar.contact-stats.total-revenue").toString(), value: printHumanFloat(this.totalRevenue, 2), right: true},
				{
					label: this.$ct("sidebar.contact-stats.total-open").toString(),
					value: printHumanFloat(this.totalOpen, 2),
					right: true,
					warning: this.totalOpen > 0
				}
			];
		},
		summary():string {
			if (this.loading) return "";
			return `${this.$ct("sidebar.contact-stats.total-open")} ${printHumanFloat(this.totalOpen, 2)}`;
		}
	},
	watch: {
		summary: {
			immediate: true,
			handler(){
				this.$emit("summary", this.summary);
			}
		},
		item(){
			this.$emit("summary", this.summary);
		}
	},
	components: {
		AppSidebarKeyValueList
	},
	i18nEx: {
		componentPrefix: "components.browse"
	}
});
